export const ConsumerAutoAddressFormUat = {
  submitButton: 'workflow.consumerAddress.auto.submitButton',
  manual: 'workflow.consumerAddress.auto.manual'
}
